import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const services = [
  {
    title: 'Corporate events',
    content: "Professional event planning for conferences, launches, and executive retreats.",
    highlight: 'from-yellow-400 to-pink-400',
  },
  {
    title: 'Team building',
    content: "Engaging activities designed to strengthen collaboration and morale.",
    highlight: 'from-green-400 to-cyan-400',
  },
  {
    title: 'Exhibitions',
    content: "Expertly managed trade shows and product showcases that leave a mark.",
    highlight: 'from-red-400 to-orange-400',
  },
  {
    title: 'Social events',
    content: "Unforgettable experiences for birthdays, anniversaries, and private parties.",
    highlight: 'from-purple-500 to-pink-400',
  },
  {
    title: 'Rentals',
    content: "High-quality equipment and decor available for all event types.",
    highlight: 'from-teal-400 to-sky-400',
  },
];

export default function ContentSections() {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { margin: '-100px' });

  return (
    <section id="services" className="py-20 bg-white">
      <motion.div
        ref={containerRef}
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 1.5, ease: 'easeOut' }}
        className="max-w-7xl mx-auto px-6"
      >
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bebas text-black bg-clip-text ">
            Our Services
          </h1>
          <div className="h-1 w-28 bg-black rounded-full mx-auto mt-3" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((section, index) => (
            <motion.div
              key={index}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: false, margin: '0px 0px -100px 0px' }}
              transition={{ 
                delay: index * 0.15, 
                duration: 0.6, 
                ease: 'easeOut' 
              }}
              className="group bg-white rounded-3xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div
                className={`h-1 w-16 rounded-full mb-5 bg-gradient-to-r ${section.highlight} transition-all duration-500 group-hover:w-24`}
              />
              <h3 className="text-2xl font-bebas  text-gray-800 mb-2 group-hover:text-[#2f1b71] transition-colors">
                {section.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {section.content}
              </p>
             
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}